
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Bordeaux dès 290€/mois – ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO est une agence Google Ads à Bordeaux certifiée Google Partner, accompagne les entreprises bordelaises pour développer leur visibilité et stimuler leurs ventes.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Bordeaux dès 290€/mois – ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO est une agence Google Ads à Bordeaux certifiée Google Partner, accompagne les entreprises bordelaises pour développer leur visibilité et stimuler leurs ventes.",
        },
      ],
    };
  },
};
